var map = {
	"./en/app.json": 4982,
	"./en/appointments.json": 4975,
	"./en/forgot-pw.json": 9428,
	"./en/form.json": 3333,
	"./en/forms-and-documents.json": 8773,
	"./en/home.json": 8649,
	"./en/login.json": 8530,
	"./en/measurement.json": 2361,
	"./en/my-information.json": 8319,
	"./en/orders.json": 7505,
	"./en/otp-verify.json": 1965,
	"./en/reset-pw-complete.json": 1435,
	"./en/reset-pw.json": 5674,
	"./en/signup-complete.json": 2185,
	"./en/signup.json": 380,
	"./es/app.json": 5954,
	"./es/appointments.json": 9446,
	"./es/forgot-pw.json": 6847,
	"./es/form.json": 6130,
	"./es/forms-and-documents.json": 5263,
	"./es/home.json": 8521,
	"./es/login.json": 4748,
	"./es/measurement.json": 3288,
	"./es/my-information.json": 8878,
	"./es/orders.json": 6078,
	"./es/otp-verify.json": 2224,
	"./es/reset-pw-complete.json": 8894,
	"./es/reset-pw.json": 661,
	"./es/signup-complete.json": 3438,
	"./es/signup.json": 177,
	"./zh-Hans/app.json": 3699,
	"./zh-Hans/appointments.json": 6232,
	"./zh-Hans/forgot-pw.json": 9791,
	"./zh-Hans/form.json": 1528,
	"./zh-Hans/forms-and-documents.json": 8783,
	"./zh-Hans/home.json": 4496,
	"./zh-Hans/login.json": 1010,
	"./zh-Hans/measurement.json": 2488,
	"./zh-Hans/my-information.json": 4671,
	"./zh-Hans/orders.json": 9152,
	"./zh-Hans/otp-verify.json": 7738,
	"./zh-Hans/reset-pw-complete.json": 4833,
	"./zh-Hans/reset-pw.json": 4575,
	"./zh-Hans/signup-complete.json": 2132,
	"./zh-Hans/signup.json": 5814,
	"./zh-Hant/app.json": 5426,
	"./zh-Hant/appointments.json": 869,
	"./zh-Hant/forgot-pw.json": 6664,
	"./zh-Hant/form.json": 8202,
	"./zh-Hant/forms-and-documents.json": 5595,
	"./zh-Hant/home.json": 2566,
	"./zh-Hant/login.json": 3730,
	"./zh-Hant/measurement.json": 3315,
	"./zh-Hant/my-information.json": 3559,
	"./zh-Hant/orders.json": 5882,
	"./zh-Hant/otp-verify.json": 5230,
	"./zh-Hant/reset-pw-complete.json": 1402,
	"./zh-Hant/reset-pw.json": 193,
	"./zh-Hant/signup-complete.json": 3594,
	"./zh-Hant/signup.json": 3247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1267;